import { UsersIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface ChatHeaderAvatarStackProps {
  count: number
  onClick?: () => void
  className?: string
}

/**
 * Displays a user icon with participant count badge.
 * Used as a trigger for the participants list popover.
 */
export const ChatHeaderAvatarStack: React.FC<ChatHeaderAvatarStackProps> = ({
  count,
  onClick,
  className,
}): ReactNode => (
  <Button
    variant="ghost"
    size="sm"
    onClick={onClick}
    className={cn('chat-header-participants-trigger gap-1.5 px-2', className)}
    aria-label={`${count} participant${count !== 1 ? 's' : ''}`}
  >
    <UsersIcon className="size-4" />
    <span className="text-sm font-medium">{count}</span>
  </Button>
)

ChatHeaderAvatarStack.displayName = 'ChatHeaderAvatarStack'
